export default function COUNTIF() {
  return <div>Excel_COUNTIF</div>;
}
